import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";

@Component({
    selector: 'app-breadcrumb',
    imports: [
        I18NextPipe
    ],
    templateUrl: './breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class BreadcrumbComponent {

  @Input() postfachLabel: string;

  @Input() isPostfach: boolean;

}
